/** API base: REACT_APP_API_BASE_URL sobrescreve; senão dev → localhost, build → produção. */
export function getApiBaseURL() {
  const fromEnv = process.env.REACT_APP_API_BASE_URL;
  if (fromEnv && String(fromEnv).trim()) {
    return String(fromEnv).replace(/\/$/, "");
  }
  return process.env.NODE_ENV === "development"
    ? "http://localhost:5001"
    : "https://secure.xpro.me";
}
